const modalActionTypes = {
  SHOW: 'SHOW',
  HIDE: 'HIDE',
  RESET_STATE: 'RESET_STATE',
};

export { modalActionTypes as default };
